var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import * as R from "ramda";
import { DATAFLOW_ANNOTATIONS_PATH, LAYOUT_ANNOTATIONS_TYPES, LAYOUT_KEYS } from "./constants/annotations.mjs";
const getDefaultTableLayout = (structure) => R.pipe(
  R.pathOr([], DATAFLOW_ANNOTATIONS_PATH),
  R.reduce((acc, annotation) => {
    if (!R.includes(annotation.type, LAYOUT_ANNOTATIONS_TYPES)) {
      return acc;
    }
    const ids = R.pipe(R.propOr("", "title"), R.split(","))(annotation);
    const layoutKey = R.prop(annotation.type, LAYOUT_KEYS);
    const currentIds = R.propOr([], layoutKey, acc);
    return __spreadProps(__spreadValues({}, acc), {
      [layoutKey]: [...currentIds, ...ids]
    });
  }, {})
)(structure);
export {
  getDefaultTableLayout
};
